import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../birthDateAction';
import fetchApi from "./fetchApi";

function fetchBirthDateAction() {
  return fetchApi('/v1/fc_api/birth_date_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchBirthDateAction;
